export const isTranslationLoaded = (id: string, text: string) => {
  if (text && text.includes(id)) {
    return false;
  }
  return true;
};
